import { StoreLink } from '../constant/link';

const showPricingPlan = () => {
    window.open(StoreLink, '_blank');
};

export default showPricingPlan;